(() => {
  angular
    .module('gm.common.directives')
    .directive('gmDateInput', gmDateInputDirective);

  function gmDateInputDirective(
    $window,
    GmyLocation,
    btgUser
  ) {
    'ngInject';

    return {
      replace: true,
      require: 'ngModel',
      restrict: 'E',
      scope: {
        readonly: '@',
        compactMode: '@',
        tip: '@?',
        country: '=?'
      },
      templateUrl: 'modules/common/directives/forms/date-input/date-input.html',
      transclude: true,

      link(scope, _element, _attrs, ctrl) {
        scope.$sc = scope;

        scope.day = '';
        scope.month = '';
        scope.year = '';

        scope.hasValue = false;
        scope.isMonthBeforeDay = true;
        scope.country = scope.country
          || ((btgUser.getProfile() && btgUser.getProfile().countryCode)
            || GmyLocation.getLocation().countryCode
            || '').toUpperCase();

        function prepareDateString(year, month, day) {
          if (!year || !month || !day) {
            return null;
          }

          const date = $window.moment([year, month - 1, day]).locale('en');

          return date.isValid() ? date.format('YYYY-MM-DD') : null;
        }

        scope.isFocus = false;

        scope.autoMoveCursor = (value, focusElement, length) => {
          if (value && ((value.toString()).length >= length)) {
            focusElement.focus();
          }
        };

        scope.isFocus = false;

        scope.moveCursorOnBackspace = (value, focusElement, valueName) => {
          if (value === '') {
            focusElement.focus();
            scope[valueName] = (scope[valueName].toString()).slice(0, -1);
          }
        };

        scope.onBlockClick = () => {
          if ((scope.year.toString()).length !== 4) {
            scope.setFirstFocus.focus();
          } else if ((scope.month.toString()).length !== 2) {
            scope.setSecondFocus.focus();
          } else {
            scope.setThirdFocus.focus();
          }
        };

        scope.onBlur = () => {
          scope.isFocus = false;
        };

        scope.onFocus = () => {
          scope.isFocus = true;
        };

        scope.$watchGroup(['day', 'month', 'year'], ([day, month, year]) => {
          scope.hasValue = day || month || year;
        });

        scope.$watch('country', (countryCode) => {
          scope.isMonthBeforeDay = (countryCode !== 'US');
        });

        scope.$watch(() => prepareDateString(scope.year, scope.month, scope.day), (dateStr) => {
          ctrl.$setViewValue(dateStr);
        }, true);
      },
    };
  }
})();
